import { Link } from "react-router-dom";

export const Privacy = () => {
  return (
    <section className="af-section" data-testid="privacy-page">
      <div className="af-container" style={{ maxWidth: 820 }}>
        <div className="af-eyebrow">Legal</div>
        <h1 className="af-h2" style={{ marginTop: 14, marginBottom: 24 }}>Privacy</h1>

        <div className="af-lede" style={{ display: "grid", gap: 16, color: "#cfd3dc" }}>
          <p>
            This privacy notice applies to the AithorityForge Solutions Ltd. website at aithorityforge.com.
          </p>
          <p>
            This site is informational. It describes our company and the products we are building. You can browse it
            without creating an account.
          </p>

          <h2 style={{ color: "#fff", fontSize: "1.15rem", fontWeight: 700, marginTop: 12 }}>What we receive</h2>
          <p>
            If you email us at <a href="mailto:stefan@aithorityforge.com" style={{ color: "#fff" }}>stefan@aithorityforge.com</a>,
            we may receive your email address and the content of your message. We use that information only to respond
            to you.
          </p>

          <h2 style={{ color: "#fff", fontSize: "1.15rem", fontWeight: 700, marginTop: 12 }}>What we do not do</h2>
          <p>
            We do not sell personal information.
          </p>

          <h2 style={{ color: "#fff", fontSize: "1.15rem", fontWeight: 700, marginTop: 12 }}>Products</h2>
          <p>
            App-specific privacy details may be added as products launch. Each product (such as PIN, Clip2SOP, and
            SoulScript) will have its own privacy information when it becomes publicly available.
          </p>

          <h2 style={{ color: "#fff", fontSize: "1.15rem", fontWeight: 700, marginTop: 12 }}>Questions</h2>
          <p>
            If you have privacy questions, contact us at{" "}
            <a href="mailto:stefan@aithorityforge.com" style={{ color: "#fff" }}>stefan@aithorityforge.com</a>.
          </p>

          <p style={{ color: "var(--af-text-muted)", fontSize: "0.9rem", marginTop: 18 }}>
            AithorityForge Solutions Ltd. — Regina, Saskatchewan, Canada.
          </p>

          <div style={{ marginTop: 24 }}>
            <Link to="/" className="af-btn af-btn-ghost" data-testid="privacy-back-home">Back to home</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Privacy;
